import React from 'react';
import CustomTabs from "../../components/CustomTabs/CustomTabs.jsx";
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import Loading from '../../components/Loading/Loading';
import Api from '../../api/Api.js';
import ReportEndpoints from '../../api/ReportEndpoints';
import { store } from '../../redux/store';
import { SET_PAGE_TITLE } from '../../redux/types';
import withStyles from "@material-ui/core/styles/withStyles";
import { Tooltip } from '@material-ui/core';
import { History, SupervisedUserCircle, TableChart, Email, Schedule } from '@material-ui/icons';
import moment from 'moment';

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import ReportResults from './ViewTabs/ReportResults.jsx';
import ScheduleTab from './ViewTabs/ScheduleTab.jsx';
import Recipients from './ViewTabs/Recipients.jsx';
import ReportHistoryTab from './ViewTabs/ReportHistoryTab.jsx';
import { scheduleDescription, cleanReportName } from '../../helpers/index.js';
import RoleCheck from '../../components/RoleCheck/RoleCheck.jsx';
import ViewersTab from './ViewTabs/ViewersTab.jsx';

class ViewReport extends React.Component {

    constructor(props) {
        super(props)
        store.dispatch({ type: SET_PAGE_TITLE, payload: "Loading Report..." });
    }

    queueStatus() {
        switch (this.state.queued) {
            case "none_queued":
                return "None Queued";
            case "done":
                return "Done";
            case "export_in_progress":
                return "Export In Progress";
            case "failed_email":
                return "Email Failure";
            case "failed_export":
                return "Export Failure";
            case "failed_sftp":
                return "FTP Failure";
            case "failed_query":
                return "Query Failure";
            case "failed_unexpectedly":
                return "Failed Unexpectedly";
            case "in_queue":
                return "In Queue";
            case "query_in_progress":
                return "Query In Progress";
            case "stopped_too_many_failures":
                return "Stopped due to failures";
            case "stopped":
                return "Stopped";
            default:
                return "";
        }
    }

    state = {
        loading: true,
        error: false,

        //Received from Server
        status: "",
        cache_timestamp: null,
        schedule: null,
        billing: false,
        active: false,
        name: '',
        files: [],
        emails: [],
        last_modified: null,
        lastrun: null,
        cache_size: 0,
        parameters: null,
        cache: [],
        queued: '',
        users: []
    }

    componentDidMount() {
        Api.get(ReportEndpoints.retrieveCache, { id: this.props.match.params.id })
            .then(({ data }) => {
                console.log(data);
                this.setState({ loading: false, ...data });
                store.dispatch({ type: SET_PAGE_TITLE, payload: cleanReportName(data.name) });
            })
            .catch((e) => {
                //TODO: Show Error Message
                console.error(e)
                this.setState({ error: true, loading: false });
            })
    }

    renderFooter() {
        return (
            <div style={{ flex: 1, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row', borderTop: '1px solid #f7f7f7', backgroundColor: '#f7f7f7', padding: '14px 28px', borderBottomLeftRadius: 6, borderBottomRightRadius: 6, boxShadow: 'inset 0px 0px 20px -8px rgba(0,0,0,0.75)' }}>
                <Tooltip
                    id="scheduleTooltip"
                    title={"Current Schedule"}
                    placement="top"
                //classes={{ tooltip: classes.tooltip }}
                >
                    <span style={{ flex: 1, textAlign: 'center', color: 'var(--success)' }}>
                        {
                            this.state.billing ?
                                "Running on Billing Schedule"
                                :
                                (
                                    this.state.schedule ?
                                        scheduleDescription(this.state.schedule)
                                        :
                                        "Not Scheduled"
                                )
                        }
                    </span>
                </Tooltip>
                <Tooltip
                    id="lastrunTooltip"
                    title={"Last Run Date"}
                    placement="top"
                //classes={{ tooltip: classes.tooltip }}
                >
                    {
                        this.state.lastrun ?
                            <span style={{ flex: 1, textAlign: 'center', fontWeight: 400, color: 'var(--primary)' }}>
                                {moment(this.state.lastrun).format('YYYY-MM-DD HH:MM')}
                            </span>
                            :
                            <span style={{ flex: 1, textAlign: 'center', fontWeight: 'bold', color: 'var(--warning)' }}>Never Ran</span>
                    }
                </Tooltip>
                <Tooltip
                    id="reportqueueTooltip"
                    title={"Queued Report Status"}
                    placement="top"
                //classes={{ tooltip: classes.tooltip }}
                >
                    <span style={{ flex: 1, textAlign: 'center', fontWeight: 400, color: "var(--info)" }}>
                        {this.queueStatus()}
                    </span>
                </Tooltip>
                <Tooltip
                    id="reportstatusTooltip"
                    title={"Running Status"}
                    placement="top"
                //classes={{ tooltip: classes.tooltip }}
                >
                    <span style={{ flex: 1, textAlign: 'center', fontWeight: 400, color: this.state.billing ? "var(--info)" : (this.state.active ? "var(--success)" : "var(--danger)") }}>
                        {this.state.billing ? "Billing" : (this.state.active ? "Active" : "Disabled")}
                    </span>
                </Tooltip>
            </div>
        );
    }

    allowedRoles = ["Admin", "OpsManager", "Ops"];
    disallowedRoles = (role) => !this.allowedRoles.some(x => x === role);

    render() {
        if (this.state.loading)
            return <Loading />;

        const { classes } = this.props;

        return (
            <GridContainer>
                <GridItem xs={12}>
                    <RoleCheck allow={this.allowedRoles}>
                        <CustomTabs
                            headerColor="success"
                            tabs={[
                                {
                                    tabName: "Results",
                                    tabIcon: TableChart,
                                    tabContent: <ReportResults cache={this.state.cache} />
                                },
                                {
                                    tabName: "Reschedule",
                                    tabIcon: Schedule,
                                    tabContent: <ScheduleTab
                                        schedule={this.state.schedule}
                                        report_id={this.props.match.params.id}
                                        changedSchedule={(new_schedule) => this.setState({ schedule: new_schedule })}
                                    />
                                },
                                {
                                    tabName: "Viewers",
                                    tabIcon: SupervisedUserCircle,
                                    tabContent: <ViewersTab
                                        users={this.state.users}
                                        admin={true}
                                        report_id={this.props.match.params.id}
                                        added={(user) => this.setState({ users: this.state.users.concat([ user ]) })}
                                        removed={(user_id) => this.setState({ users: this.state.users.filter(x => x.id !== user_id) })}
                                    />
                                },
                                {
                                    tabName: "Recipients",
                                    tabIcon: Email,
                                    tabContent: <Recipients
                                        emails={this.state.emails}
                                        admin={true}
                                        report_id={this.props.match.params.id}
                                        added={(email) => this.setState({ emails: this.state.emails.concat([ email ]) })}
                                        removed={(email_id) => this.setState({ emails: this.state.emails.filter(x => x.id !== email_id) })}
                                    />
                                },
                                {
                                    tabName: "History",
                                    tabIcon: History,
                                    tabContent: <ReportHistoryTab files={this.state.files} />
                                }
                            ]}
                            footer={this.renderFooter()}
                        />
                    </RoleCheck>
                    <RoleCheck allow={(role) => this.disallowedRoles(role)}>
                        <CustomTabs
                            headerColor="success"
                            tabs={[
                                {
                                    tabName: "Results",
                                    tabIcon: TableChart,
                                    tabContent: <ReportResults />
                                },
                                {
                                    tabName: "Viewers",
                                    tabIcon: SupervisedUserCircle,
                                    tabContent: <ViewersTab users={this.state.users} />
                                },
                                {
                                    tabName: "Recipients",
                                    tabIcon: Email,
                                    tabContent: <Recipients emails={this.state.emails} />
                                },
                                {
                                    tabName: "History",
                                    tabIcon: History,
                                    tabContent: <ReportHistoryTab files={this.state.files} />
                                }
                            ]}
                            footer={this.renderFooter()}
                        />
                    </RoleCheck>
                </GridItem>
            </GridContainer>
        );
    }
}

export default withStyles(extendedFormsStyle)(ViewReport);